import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { SEO } from '../seo/SEO';

export const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy | Banga.ai"
        description="Learn about how we collect, use, and protect your personal information at Banga.ai"
      />
      
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8 transition-colors">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>

          <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 md:p-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
            
            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Being a collaborative community, the top-priority of Banga.ai will always be the relationship with its community. 
                Banga.ai is therefore firmly committed to the security and protection of the personal integrity of our Users of 
                the Services (as defined in the Terms of use) and their contacts.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">Information We Collect</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-3">Installation and Use</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                When you use our website, we collect, process and retain personal information from you and any devices you may use. 
                This information may include:
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-6">
                <li>Geo-location</li>
                <li>IP address</li>
                <li>Device ID or unique identifier</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Connection information</li>
                <li>Screen resolution</li>
                <li>Usage statistics</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-3">User Profile</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                When creating a profile, we require:
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-6">
                <li>Email address</li>
                <li>Password</li>
                <li>Username</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">How We Use Your Information</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                We use your information to:
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-6">
                <li>Provide and improve our services</li>
                <li>Send you updates about new features</li>
                <li>Customize your experience</li>
                <li>Analyze usage patterns</li>
                <li>Ensure security of our services</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">Contact Information</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                For any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg">
                <p className="text-gray-700 dark:text-gray-300">
                  Tripple O Solutions<br />
                  35, Raufa Williams Street<br />
                  Off Adelabu Street, Surulere<br />
                  Lagos state, Nigeria
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};